import type { Instance } from '@nx/state';
import { CDC_ENRICHMENT_MODE } from '@nx/state';
import { isNotNullish } from '@nx/stdlib';

export const instanceHasCDCEnabled = (instance: Instance) =>
  isNotNullish(instance.desiredSettings.cdcEnrichmentMode) &&
  instance.desiredSettings.cdcEnrichmentMode !== CDC_ENRICHMENT_MODE.OFF;
